
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import { ProductDto } from './ProductDto';
import { ProductCategoryDto } from './ProductCategoryDto';
import { ProductSearchOptionsDto } from './ProductSearchOptionsDto';
import { ProductCategoryType } from './ProductCategoryType';

@Injectable()
export class ProductService {

  constructor(private http: HttpClient) { }

   search(options?: ProductSearchOptionsDto): Promise<ProductDto[]> {
    return this.http.post(environment.apiUrl + `api/product/search` ,typeof(options) === 'string' ? '"' + options + '"'  : options,{headers:{"Content-Type":"application/json"}}).map(response => <any>response).toPromise(); 
  }
    get(): Promise<ProductDto[]> {
    return this.http.get(environment.apiUrl + `api/product`).map(response => <any>response).toPromise(); 
  }
    byCategoryType(type?: ProductCategoryType): Promise<ProductCategoryDto[]> {
    return this.http.get(environment.apiUrl + `api/product/categories?type=${type}`).map(response => <any>response).toPromise(); 
  }
  

  private handleError(error: any) {
    console.error('ApiService::handleError', error);
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/typewriter/output/ProductController.ts